import { ISalePageDetailV2Response } from '@/api/types';
import { getRouterPath, ProxyGachaSelectBottomSheet } from '@/components';
import webViewService from '@/lib/webViewService';
import { useOverlay } from '@vuddy/components';
import { getClientSideUserAgent } from '@vuddy/utils';
import { useRouter } from 'next/navigation';

interface IuseHandleGachaUnUsedTicketsProps {
  userGachaTicketIds: number[];
  amount: number;
  salePage: ISalePageDetailV2Response;
}

export const useHandleGachaUnUsedTickets = ({
  userGachaTicketIds,
  amount,
  salePage,
}: IuseHandleGachaUnUsedTicketsProps) => {
  const router = useRouter();
  const isAppWebView = webViewService.isAppWebView(getClientSideUserAgent());
  const routerPath = getRouterPath({
    isAppWebView,
  });
  const { openBottomSheet } = useOverlay();

  const onClickUnUsedTicket = () => {
    if (salePage.gacha?.isProxyCompleteAllowed) {
      openBottomSheet({
        component: ProxyGachaSelectBottomSheet,
        props: {
          channelName: salePage.channel.name,
          resultAutoCompleteAt: salePage.gacha.resultAutoCompleteAt,
          handleProxyGachaRequest: _handleGachaRequest(true),
          handleGachaRequest: _handleGachaRequest(false),
        },
      });
    } else {
      _handleGachaRequest(false)();
    }
  };

  const _handleGachaRequest =
    (isProxy: boolean) => (onClose?: VoidFunction) => {
      if (amount <= 0) {
        onClose?.();
        return router.refresh();
      }

      const url = routerPath.gachaPolling({
        userGachaTicketIds,
        fromSalePage: true,
        options: {
          forceWebUrl: isProxy,
        },
      });

      if (!isAppWebView || isProxy) {
        sessionStorage.setItem('isProxy', isProxy ? 'true' : 'false');
        router.push(url);
      } else {
        onClose?.();
        if (typeof window !== 'undefined') {
          window.location.href = url;
        }
      }
    };

  return {
    onClickUnUsedTicket,
  };
};
